export const JSM_BASE_URL = '/gateway/api/jsm/ops/web/';
